/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Timezone_America_Newyork3Inputs */

const he_timezone_america_newyork3 = /** @type {(inputs: Timezone_America_Newyork3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eastern Time (US)`)
};

const en_timezone_america_newyork3 = /** @type {(inputs: Timezone_America_Newyork3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eastern Time (US)`)
};

/**
* | output |
* | --- |
* | "Eastern Time (US)" |
*
* @param {Timezone_America_Newyork3Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const timezone_america_newyork3 = /** @type {((inputs?: Timezone_America_Newyork3Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timezone_America_Newyork3Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_timezone_america_newyork3(inputs)
	return en_timezone_america_newyork3(inputs)
});
export { timezone_america_newyork3 as "timezone_America_NewYork" }